import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { Select } from 'semantic-ui-react';

export const GET_MANUFACTURERS_QUERY = gql`
    query getManufacturers(
        $salon: ID!
        $manufacturer: ID!
        $withManufacturer: Boolean!
    ) {
        viewer {
            id
            ... on Administrator {
                salon(id: $salon) {
                    id
                    manufacturers {
                        nodes {
                            id
                            ...manufacturer
                        }
                    }
                }
            }
        }

        manufacturer(id: $manufacturer) @include(if: $withManufacturer) {
            id
            ...manufacturer
        }
    }

    fragment manufacturer on Manufacturer {
        name
    }
`;

function ManufacturerSelect({ meta, dispatch, salon: _salon, value, ...props }) {
    const salon = useSelector(({ user }) => user.get('salon'));
    const { data, loading } = useQuery(GET_MANUFACTURERS_QUERY, {
        variables: {
            salon,
            manufacturer: value || '',
            withManufacturer: !!value,
        },
    });

    const options =
        !loading && data && data.viewer
            ? data.viewer.salon.manufacturers.nodes.map(item => ({
                  value: item.id,
                  text: item.name,
              }))
            : [];

    return <Select loading={loading} options={options} value={value} {...props} />;
}

export default ManufacturerSelect;
